import { render } from "./Interventi.vue?vue&type=template&id=22f420f1&scoped=true&ts=true"
import script from "./Interventi.vue?vue&type=script&lang=ts"
export * from "./Interventi.vue?vue&type=script&lang=ts"

import "./Interventi.vue?vue&type=style&index=0&id=22f420f1&scoped=true&lang=css"

import exportComponent from "/Users/andrea/Sites/app_apib/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22f420f1"]])

export default __exports__